var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNext = function SvgNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.107 5.679-4 3.84A1.02 1.02 0 0 1 7.4 9.8c-.256 0-.512-.094-.707-.281a.93.93 0 0 1 0-1.358l2.293-2.2H1.4c-.552 0-1-.43-1-.96 0-.532.448-.96 1-.96h7.586L6.693 1.838a.93.93 0 0 1 0-1.357 1.03 1.03 0 0 1 1.414 0l4 3.84a.93.93 0 0 1 0 1.357"
  })));
};
export default SvgNext;